import React, { useEffect, useState } from "react";
import interviewerIcon from "../../../assets/images/interviewer_purple.svg";

interface InterviewerDisplayProps {
  isInterviewerSpeaking: boolean;
  isCompact?: boolean; // For when displaying alongside graphs
}

const InterviewerDisplay: React.FC<InterviewerDisplayProps> = ({
  isInterviewerSpeaking,
  isCompact = false,
}) => {
  const [isInterviewerThinking, setIsInterviewerThinking] = useState(false);

  // Handle interviewer's speaking/animation state
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isInterviewerSpeaking) {
      setIsInterviewerThinking(true);
    } else {
      timeoutId = setTimeout(() => {
        setIsInterviewerThinking(false);
      }, 700);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isInterviewerSpeaking]);

  // Different layouts for compact vs full display
  if (isCompact) {
    return (
      <div className="interviewer-display flex flex-col items-center">
        <div
          className={`interviewer-avatar ${
            isInterviewerSpeaking
              ? "breathing-animation-blue"
              : isInterviewerThinking
              ? "breathing-animation-blue"
              : ""
          }`}
        >
          <img
            className="w-24 h-24 rounded-full bg-[#ced4da]"
            src={interviewerIcon}
            alt="AI Interviewer"
          />
        </div>
        <div className="interviewer-title text-[#1f2024] font-[Product Sans] text-sm font-bold mt-2">
          Sr. WeKruit Consultant
        </div>
      </div>
    );
  }

  return (
    <div className="interviewer-display flex flex-col items-center relative">
      <div
        className={`interviewer-avatar ${
          isInterviewerSpeaking
            ? "breathing-animation-blue"
            : isInterviewerThinking
            ? "breathing-animation-blue"
            : ""
        }`}
      >
        <img
          className="w-[12.25rem] h-[12.25rem] rounded-full bg-[#ced4da]"
          src={interviewerIcon}
          alt="AI Interviewer"
        />
      </div>
      <div className="interviewer-title mt-4 text-[#1f2024] font-[Product Sans] text-[1rem] font-bold leading-6">
        Sr. WeKruit Consultant
      </div>
    </div>
  );
};

export default InterviewerDisplay;
